import { Box, LoadingOverlay, Text } from '@mantine/core';
import { useGetDebtor } from 'api';
import { debtorAtom } from 'app/Private/Clients/Detail/client-atom';
import { useAtom } from 'jotai';
import { i18nKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { isNullish } from 'remeda';
import { treatClient } from 'shared/serializer';
import { ClientHeader } from './ClientHeader';
import { ClientTabs } from './ClientTabs';
import { useLoadDebtorAiSummary } from './InfoTab/components/AiSummaryPanel/hooks/use-load-debtor-ai-summary';

export const Client = () => {
  const { t } = useTranslation();
  const { id: debtorId } = useParams<{ id: string }>();

  const [{ debtor: debtorFromAtom }, setDebtorAtom] = useAtom(debtorAtom);
  const { data: debtorDetailsResponse, isError, refetch } = useGetDebtor(debtorId);
  const { isAiSummaryInitialLoading } = useLoadDebtorAiSummary({ id: debtorId });

  const isDebtorFromAtomLoading = isNullish(debtorFromAtom);

  useEffect(() => {
    if (isNullish(debtorDetailsResponse?.data)) return;
    const processedClient = treatClient(debtorDetailsResponse.data);
    setDebtorAtom({ debtor: processedClient, refetch });
  }, [debtorDetailsResponse?.data, refetch, setDebtorAtom]);

  if (isError)
    return (
      <Box>
        <Text>{t(i18nKeys.CLIENT.GENERAL_INFO_TAB.COULD_NOT_FETCH)}</Text>
      </Box>
    );

  // Block on Ai Summary loading because it affects the layout of the page
  if (isDebtorFromAtomLoading || isAiSummaryInitialLoading || !debtorDetailsResponse)
    return (
      <Box h="100%" pos="relative">
        <LoadingOverlay visible />
      </Box>
    );

  return (
    <>
      <ClientHeader />
      <ClientTabs />
    </>
  );
};
